export default (that) => [
  {
    text: that.$l('menu_text_confirm') || '通过',
    icon: 'el-icon-circle-check',
    menuType: 'confirm',
    disabled: ({ replysStatus }) => 'S' !== replysStatus,
  },
  {
    text: that.$l('menu_text_reject') || '修改出货数量',
    icon: 'el-icon-edit',
    menuType: 'reject',
    divided: true,
    disabled: ({ replysStatus }) => 'S' !== replysStatus,
  },
  {
    text: that.$l('menu_text_revoke') || '撤回返答',
    icon: 'el-icon-edit-outline',
    menuType: 'reject',
    disabled: ({ replysStatus }) => 'Y' !== replysStatus,
  },
]
